import React from "react";

import { useTodosContext } from "../../context/todoContext";

import Wrapper from "./Todo.styled";
import { ReactComponent as IconClose } from "../../assets/images/icon-cross.svg";

const Todo = ({ status, todo, id }) => {
  const { changeTodoStatus, clearTodo } = useTodosContext();
  return (
    <Wrapper>
      <input
        type="checkbox"
        id={id}
        name="status"
        checked={status}
        onChange={(e) => {
          const { checked } = e.target;
          changeTodoStatus(id, checked);
        }}
      />
      <label htmlFor={id}>{todo}</label>

      <IconClose className="icon" onClick={() => clearTodo(id)} />
    </Wrapper>
  );
};

export default Todo;
